export const Z_INDEX = {
    ONE: 1,
    ONE_THOUSAND_300: 1300,
};
